/**
 * 
 * initialiZe the GA
 * 
 */
export const initGaVars = () => {
    const response = {
        cid: '',
        utmString: ''
    }

    // ------------------------------------------------
    // GA client id
    // ------------------------------------------------
    let clientId = null;

    function getGAClientID() {
        let trackers = window.ga.getAll();
        let i, len;
    
        for (i = 0, len = trackers.length; i < len; i += 1) {
            if (trackers[i].get('trackingId') === 'UA-19748216-8') {
                let clientid = trackers[i].get('clientId');
                return clientid;
            }
        }
    
        return null;
    }

    if (window.ga !== undefined) {
        if (typeof window.ga.getAll !== 'function') return response;

        clientId = getGAClientID()
    }

    

    // ------------------------------------------------
    // Start getting utm string
    // ------------------------------------------------
    const utmString = getUtmString();

    if (clientId) {
        response.cid = clientId;
    }

    if (utmString) {
        response.utmString = utmString;
    }

    return response;
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    const cookieValue = decodeURIComponent(results[2].replace(/\+/g, ' '));

    const getValue = () => {
        if (cookieValue) {
          return cookieValue
        }
        return null;
    };

    //    console.log('cookie value', cookieValue);

    return { getValue };

  
}

/**
 * 
 * combine the utm codes to 1 string
 * 
 */
function getUtmString() {
    let utmCode = "";

    const g = getCookie("__gtm_campaign_url")
    

    const utmCookies = [
        { name: "utm_campaign", cookie: getParameterByName('utm_campaign',g) },
        { name: "utm_medium", cookie: getParameterByName('utm_medium',g) },
        { name: "utm_source", cookie: getParameterByName('utm_source',g) },
        { name: "utm_content", cookie: getParameterByName('utm_content',g) }
    ];

    function utmCombine(utmcode, name) {
        if (utmcode && utmcode.getValue()) {
            return name + ":=" + utmcode.getValue() + "|";
        }

        return null;
    }

    for (var i = 0; i < utmCookies.length; i++) {
        let combineUtm = utmCombine(
            utmCookies[i].cookie,
            utmCookies[i].name
        );

        if (combineUtm) {
            utmCode += combineUtm;
        }
    }

    return utmCode.substring("|", utmCode.length - 1);
}

/**
 * 
 * get the cookie from browser
 * 
 * @param {string} cname 
 */
function getCookie(cname) {
    // console.log('cookie name', cname);

    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    var cookieValue = "";

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }

        if (c.indexOf(name) === 0 || c.indexOf(name) === "0") {
            cookieValue = c.substring(name.length, c.length);

            return cookieValue
        }
    }

    const getValue = () => {
        if (cookieValue) {
            let value = cookieValue.split("|");
            return value[value.length - 1];
        }

        return null;
    };

    //    console.log('cookie value', cookieValue);

    return { getValue };
}

/**
 * 
 * google analytics push events
 * 
 * @param {string} page 
 * @param {string} title 
 */
export const gaEvents = (page, title) => {
    // console.log('--------------------------------------------');
    // console.log(page, '--------------', title);
    // console.log('--------------------------------------------');

    if (window.ga !== undefined) {
        window.ga("gtm1.send", "pageview", {
            // clientId: this.gaClientId,
            page: page,
            title: title
        });
    }
}

/**
 * 
 * push fb events to fb
 * 
 * @param {string} label 
 */
export const fbEvents = (label) => {
    if (window.fbq !== undefined) {
        window.fbq("track", label);
    }
}

